import { Moon, Sun, Sparkles } from 'lucide-react';
import { useTheme } from '@/hooks/useTheme';

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const baseClasses = 'w-8 h-8 rounded-md flex items-center justify-center border transition-all';
  const inactiveClasses = 'border-border-subtle text-text-muted bg-bg-primary hover:border-accent-blue';

  return (
    <div className="flex gap-2">
      <button
        onClick={() => setTheme('dark')}
        title="Tema Oscuro"
        className={`${baseClasses} ${
          theme === 'dark'
            ? 'border-accent-blue text-accent-blue bg-accent-blue/10'
            : inactiveClasses
        }`}
      >
        <Moon size={14} />
      </button>
      <button
        onClick={() => setTheme('light')}
        title="Tema Claro"
        className={`${baseClasses} ${
          theme === 'light'
            ? 'border-accent-blue text-accent-blue bg-accent-blue/10'
            : inactiveClasses
        }`}
      >
        <Sun size={14} />
      </button>
      <button
        onClick={() => setTheme('aurora')}
        title="Tema Aurora"
        className={`${baseClasses} ${
          theme === 'aurora'
            ? 'border-accent-purple text-accent-purple bg-accent-purple/10'
            : inactiveClasses
        }`}
      >
        <Sparkles size={14} />
      </button>
    </div>
  );
}
